import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row } from 'react-bootstrap'
import { useHistory, withRouter } from 'react-router-dom'
import ListSelections from './list-selections'
import ListPresentation from './list-presentation'
import DashboardSingleListAddContactModal from './modals/add-contact-modal'
import { requestActiveCompanyDetails, requestActiveCompanyNotes, resetActiveCompanyDetails, resetActiveCompanyNotes, resetActiveCompanyStatus, resetAddListCompanyNote, resetAddNewClient, resetDeleteListCompanyNote, resetRemoveExistingClient, retrieveActiveCompanyStatus, retrieveSingleListDetails, retrieveSingleListResponses, resetAddListCompanyResponse, retrieveCompanyDeletions, resetRemoveCompanyListing, setCompanyList, resetCompanyList, resetSingleListDetails, setDisplayIndex, resetAddNewContact } from '../../../redux/actions/single-list'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import { ToastContainer } from 'react-toastify'

import './style.scss'

const Index = props => {

	const dispatch = useDispatch()
	const listId = props.match.params.id

	const history = useHistory()

	const fetchFullListError = useSelector(state => state.singleList.fetchFullList.error)
	const fetchFullListLoading = useSelector(state => state.singleList.fetchFullList.loading)

	const deleteNoteStatus = useSelector(state => state.singleList.removeSingleNote.status)
	const deleteNoteError = useSelector(state => state.singleList.removeSingleNote.error)

	const addNoteStatus = useSelector(state => state.singleList.addSingleNote.status)
	const addNoteError = useSelector(state => state.singleList.addSingleNote.error)

	const addNewClientStatus = useSelector(state => state.singleList.addClient.status)
	const addNewClientError = useSelector(state => state.singleList.addClient.error)

	const addResponseStatus = useSelector(state => state.singleList.addSingleResponse.status)
	const addResponseError = useSelector(state => state.singleList.addSingleResponse.error)


	const removeExistingClientStatus = useSelector(state => state.singleList.removeClient.status)
	const removeExistingClientError = useSelector(state => state.singleList.removeClient.error)

	const activeDisplay = useSelector(state => state.singleList.activeDisplay)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	const list = useSelector(state => state.singleList.list)

	const deletions = useSelector(state => state.singleList.deletions)
	const deletionsLoading = useSelector(state => state.singleList.fetchListDeletions.loading)

	const deleteCompanyError = useSelector(state => state.singleList.removeSingleCompany.error)
	const deleteCompanyStatus = useSelector(state => state.singleList.removeSingleCompany.status)

	const addContactStatus = useSelector(state => state.singleList.addContact.status)
	const addContactError = useSelector(state => state.singleList.addContact.error)

	const displayIndex = useSelector(state => state.singleList.displayIndex)

    const modal = useSelector(state => state.singleList.showModals)
	const [maintainLayout, setMaintainLayout] = useState(false)


	const flushDetails = () => {
		dispatch(resetSingleListDetails())
		dispatch(resetActiveCompanyDetails())
		dispatch(resetActiveCompanyNotes())
		dispatch(resetActiveCompanyStatus())
		dispatch(resetDeleteListCompanyNote())
		dispatch(resetAddListCompanyNote())
		dispatch(resetAddNewClient())
		dispatch(resetRemoveExistingClient())
		dispatch(resetAddListCompanyResponse())
	}

	useEffect(() => {
		flushDetails()
	}, [])

	useEffect(() => {
		if(addResponseStatus){
			sendSuccessNotification("Responsen ble lagret.")
			dispatch(resetAddListCompanyResponse())
			dispatch(retrieveSingleListResponses({companyId: selectedCompany, id: listId}))
		  }
	}, [addResponseStatus])

	useEffect(() => {
		if(addResponseError){
			sendErrorNotification("Kunne ikke legge til respons.")
			dispatch(resetAddListCompanyResponse())
		  }
	}, [addResponseError])

	useEffect(() => {
		if(removeExistingClientError){
			sendErrorNotification("Kunne ikke fjerne kunde.")
			dispatch(resetRemoveExistingClient())
			dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
		}
	}, [removeExistingClientError])

	useEffect(() => {
		if(removeExistingClientStatus){
			sendSuccessNotification("Kunden ble fjernet.")
			dispatch(resetRemoveExistingClient())
			dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
		}
	}, [removeExistingClientStatus])

	useEffect(() => {
		if(addNewClientError){
			sendErrorNotification("Kunne ikke legge til kunde.")
			dispatch(resetAddNewClient())
			dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
		}
	}, [addNewClientError])

	useEffect(() => {
		if(addNewClientStatus){
			sendSuccessNotification("Kunden ble lagt til.")
			dispatch(resetAddNewClient())
			dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
		}
	}, [addNewClientStatus])

	useEffect(() => {
		if(addNoteError){
			sendErrorNotification("Kunne ikke legge til notat.")
			dispatch(resetAddListCompanyNote())
		}
	}, [addNoteError])

	useEffect(() => {
		if(addNoteStatus){
			dispatch(resetAddListCompanyNote())
			if(activeDisplay.general.organizationNumber){
				dispatch(requestActiveCompanyNotes({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
			}
		}
	}, [addNoteStatus])

	useEffect(() => {
		if(deleteNoteError){
			dispatch(resetDeleteListCompanyNote())
			dispatch(retrieveSingleListResponses({companyId: selectedCompany, id: listId}))
			sendErrorNotification("Kunne ikke slette notat.")
		}
	}, [deleteNoteError])

	useEffect(() => {
		if(deleteNoteStatus){
			if(activeDisplay.general.organizationNumber){
				dispatch(resetDeleteListCompanyNote())
				dispatch(requestActiveCompanyNotes({companyId: selectedCompany, listId: listId, organizationNumber: activeDisplay.general.organizationNumber}))
				sendSuccessNotification("Notat ble slettet.")
			}
		}
	}, [deleteNoteStatus])

	useEffect(() => {

		if(listId && selectedCompany){
			dispatch(retrieveSingleListDetails({companyId: selectedCompany, id: listId}))
			dispatch(retrieveSingleListResponses({companyId: selectedCompany, id: listId}))
		}

	}, [listId, selectedCompany])

	useEffect(() => {
		if(list && list.length > 0 && !activeDisplay.general.name){
			const firstCompany = list && list[0].organisasjonsnummer
			if(firstCompany){
				dispatch(requestActiveCompanyDetails({organizationNumber: firstCompany}))
				dispatch(requestActiveCompanyNotes({companyId: selectedCompany, listId: listId, organizationNumber: firstCompany}))
				dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: firstCompany}))
				dispatch(setDisplayIndex(0))
			}
		}
	}, [list])

	useEffect(() => {
		if(deleteCompanyError){
			sendErrorNotification("Kunne ikke fjerne virksomhet.")
			dispatch(resetRemoveCompanyListing())
		}
	}, [deleteCompanyError])

	useEffect(() => {
		if(deleteCompanyStatus){
			dispatch(retrieveSingleListDetails({companyId: selectedCompany, id: listId}))
			dispatch(retrieveSingleListResponses({companyId: selectedCompany, id: listId}))
			sendSuccessNotification("Virksomheten ble fjernet fra listen.")
			dispatch(resetRemoveCompanyListing())
			setMaintainLayout(true)
		}
	}, [deleteCompanyStatus])

	useEffect(() => {
		if(fetchFullListError){
			flushDetails()
			history.push('/dashboard/lister')
		}
	}, [fetchFullListError])

	useEffect(() => {
		if(displayIndex){
			if(list[displayIndex].organisasjonsnummer !== activeDisplay.general.organizationNumber){
				dispatch(requestActiveCompanyDetails({organizationNumber: list[displayIndex].organisasjonsnummer}))
				dispatch(retrieveActiveCompanyStatus({companyId: selectedCompany, listId: listId, organizationNumber: list[displayIndex].organisasjonsnummer}))
				dispatch(requestActiveCompanyNotes({companyId: selectedCompany, listId: listId, organizationNumber: list[displayIndex].organisasjonsnummer}))
			}
		}
	}, [displayIndex])
	
	const keyDownHandler = e => {
		if(e){
			switch(e.key){
				case "ArrowDown":
					if(displayIndex < list.length){
						dispatch(setDisplayIndex(displayIndex + 1))
					}
					e.preventDefault();
				break;
				case "ArrowUp":
					if(displayIndex > 0){
						dispatch(setDisplayIndex(displayIndex - 1))
					}
					e.preventDefault();
				break;
				default:break;
			}
		}
	}

	useEffect(() => {
		document.addEventListener("keydown", keyDownHandler);
		return () => { document.removeEventListener("keydown", keyDownHandler); };
	}, [keyDownHandler]);

	useEffect(() => {
		if(addContactStatus){
			sendSuccessNotification("Kontakt ble lagt til.")
			dispatch(resetAddNewContact())
		}
	}, [addContactStatus])

	useEffect(() => {
		if(addContactError){
			sendErrorNotification("Kunne ikke legge til kontakt.")
			dispatch(resetAddNewContact())
		}
	}, [addContactError])


	return(
		<section className="dashboard-single-list-section">
			<div className="inner-dashboard-single-list-container">
				<Row className="dashboard-single-list-row">
					<ListSelections maintainLayout={maintainLayout}/>
					<ListPresentation/>
				</Row>
            	{modal.addContactModal ? <DashboardSingleListAddContactModal/>:null}
			</div>
			<ToastContainer/>
		</section>
	)
}

export default withRouter(Index)